import { action as apiAction } from 'api/Api'
import {
  add as addActivity
} from '../redux/activities'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  message: any
}

const requestSendMessage = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, message } = payload

  const tempId = `temp-${new Date().getTime()}`

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId
  const currentUserId = state.kanbo.currentUser.id

  const optimisticAction = optimisticDispatch(dispatch, addActivity({
    cardId,
    activity: {
      id: tempId,
      from: `u:${currentUserId}`,
      timestamp: Date.now(),
      tags: ['important', 'message'],
      data: {
        action: 'AddCommentOnCard',
        rtMessage: message,
        cardId,
        boardId
      },
      isBusy: true
    }
  }))

  try {
    await apiAction('AddCommentOnCard', {
      cardId,
      rtMessage: message
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestSendMessage
